import React, { useEffect } from 'react'
import styles from "./ManageForms.styles"

import Loadable from '../../../components/loadable/Loadable'
import Heading from '../../../components/heading/Heading'
import TabbedNavigationWithDefinedTitle from '../../../components/tabbednavigation/TabbedNavigationWithDefinedTitle'
import ManageFederalForms from './managefederalforms/ManageFederalForms'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setCurrentTabIndex } from './ManageFormsSlice'
import { HEADING } from '../../../components/heading/constants/constants'
import ManageStateForms from './managestateforms/ManageStateForms'
import ManageReconciliationForms from './managereconciliationforms/ ManageReconciliationForms'
import { getFederalForms, getFederalPayers, getTaxYears } from './ManageFormsSaga'
import { componentKey as dataLoaderComponentKey } from "../../loaders/dataloader/DataLoaderSlice"
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import { useLocation } from 'react-router-dom'
import { MANAGE_FORMS_LOADING_STATES, MANAGE_FORMS_MESSAGE_MAP, TAB_PATHS } from './constants'
import ManageStatePayrollForms from './managestatepayrollforms/ManageStatePayrollForms'
import { PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../constants/constants'
import { FEATURE_FLAG } from '../../../featureFlags'


const ManageForms = () => {

    useGarbageCollector(componentKey)
    const dispatch = useDispatch();
    const location = useLocation();

    const { loadingState, federalPayersLoader, federalTaxYearsLoader, federalPayers, federalTaxYear, currentTabIndex, manageFormsLoad } = useSelector(state => state[componentKey])
    const { statesList } = useSelector(state => state[dataLoaderComponentKey])

    useEffect(() => {

        const paths = location.pathname.split("/");
        const currentPath = paths[paths.length - 1];
        let index = 0;

        switch (currentPath) {
            case TAB_PATHS.FEDERAL_FORMS:
                index = 0;
                break;

            case TAB_PATHS.STATE_FORMS:
                index = 1;
                break;

            case TAB_PATHS.RECONCILIATION_FORMS:
                index = 2;
                break;  

            case TAB_PATHS.STATE_PAYROLL_FORMS:
                index = 3;
                break;          
        }

        dispatch(setCurrentTabIndex(index));
    }, [location.pathname])

    useEffect(() => {
        dispatch(getFederalPayers())
        dispatch(getTaxYears())
        dispatch(getFederalForms())
    }, [])

    const tabListWithTitleObj = [
        {
            title: {
                titleText: "Manage Federal Forms",
            },
            tabBodyComponent: <ManageFederalForms federalPayers={federalPayers} federalTaxYear={federalTaxYear} />,
            linkTo: `/${TAB_PATHS.FEDERAL_FORMS}`
        },
        {
            title: {
                titleText: "Manage State Forms",
            },
            tabBodyComponent: <ManageStateForms statePayers={federalPayers} stateTaxYear={federalTaxYear} />,
            linkTo: `/${TAB_PATHS.STATE_FORMS}`
        },
        ...(FEATURE_FLAG.SHOW_RECONCILIATION ? [{
            title: {
                titleText: "Manage Reconciliation Forms",
            },
            tabBodyComponent: <ManageReconciliationForms federalPayers={federalPayers} federalTaxYear={federalTaxYear} federalStateList={statesList} />,
            linkTo: `/${TAB_PATHS.RECONCILIATION_FORMS}`
        }] : []),
        ...(FEATURE_FLAG.SHOW_STATE_PAYROLL ? [{
            title: {
                titleText: "Manage State Payroll Forms",
            },
            tabBodyComponent: <ManageStatePayrollForms />,            
            linkTo: `/${TAB_PATHS.STATE_PAYROLL_FORMS}`
        }] : [])
    ];

    return (
        <Loadable currentState={federalPayersLoader.state} loadingStates={[MANAGE_FORMS_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING]} messageMap={MANAGE_FORMS_MESSAGE_MAP} isNewLoadable={true}>
            <Loadable currentState={federalTaxYearsLoader.state} loadingStates={[MANAGE_FORMS_LOADING_STATES.TAX_YEARS_LOADING]} messageMap={MANAGE_FORMS_MESSAGE_MAP} isNewLoadable={true}>
                <Loadable currentState={loadingState.state} loadingStates={[PAGE_STATE.LOADING]} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
                    <div>
                        <div style={styles.gridContainer}>
                            <TabbedNavigationWithDefinedTitle
                                tabListWithTitleObj={tabListWithTitleObj}
                                useSeparateUrl={true}
                                sectionPath={"/forms/manage"}
                                activeTabIndex={currentTabIndex}
                                onChangeTabCb={(activeTabIdx) => dispatch(setCurrentTabIndex(activeTabIdx))}
                                unMountChildComponentOnSwitch={true}
                            />
                        </div>
                    </div>
                </Loadable>
            </Loadable>
        </Loadable>
    )
}

export default ManageForms
